function EmptyTodo(params) {
    return <h2>Organize your time. Place your tasks...</h2>
}

export { EmptyTodo }
